import { render, staticRenderFns } from "./returkirimanfrminduk.vue?vue&type=template&id=04cf5a54"
import script from "./returkirimanfrminduk.vue?vue&type=script&lang=js"
export * from "./returkirimanfrminduk.vue?vue&type=script&lang=js"
import style0 from "./returkirimanfrminduk.vue?vue&type=style&index=0&id=04cf5a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports